<div class="comp-header">
  <div class="comp-header__inner">
    <h1 class="h3">Prispolitikker</h1>
    <div class="comp-header__actions">
      <button [admRequiresFeatureRole]="roles['price-policy.write']" mat-button type="button" (click)="openActionLog()">
        <mat-icon>list</mat-icon>
        <span>Hændelseslog</span>
      </button>
      <button
        [admRequiresFeatureRole]="roles['price-policy.write']"
        mat-flat-button
        color="primary"
        type="button"
        (click)="openPricePolicyManagement(null)">
        <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
        <span>Opret prispolitik</span>
      </button>
    </div>
  </div>
  <div stickyHeaderCompTitleHelper>
    @if (state.focusedPricePolicy()) {
      @let focusedPricePolicy = state.focusedPricePolicy();
      <div class="comp-header__deeplinked">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
        Listen er filtreret til&nbsp;
        <strong>Pris politik : {{ focusedPricePolicy?.name }}</strong>
        <button (click)="state.resetFilter()" class="actions__reset margin--left-m" mat-stroked-button>Nulstil</button>
      </div>
    } @else {
      <div class="comp-header__queries">
        <adm-text-search placeholder="Søgeord" (search$)="querySearchInput($event)" [searchText]="state.filters().query ?? ''" />

        <adm-org-typeahead
          [initialId]="state.filters().organizationId ?? undefined"
          [resetTrigger]="state.resetAllFiltersTrigger()"
          (itemSelected)="organizationSelected($event)"
          (organizationsFetched)="organizationsFetched($event)" />

        <adm-admin-enum-select-list
          label="Vælg type"
          [enumObject]="typeOptions"
          [translatePipe]="translatePricePolicyTypePipe"
          [initialValue]="state.filters().type"
          (enumChanged)="typeSelected($event)" />

        <div class="comp-header__filter-checkbox">
          <mat-slide-toggle
            [checked]="state.filters().policySearchType === PricePolicySearchType.GlobalOnly"
            (change)="toggleGlobalPrices($event.checked)"
            color="primary">
            Vis kun globale
          </mat-slide-toggle>
        </div>
        <button class="comp-header__reset-button" (click)="state.resetFilter()" mat-stroked-button>Nulstil</button>
      </div>
    }
  </div>
</div>
<div class="comp-main price-policies-overview">
  <ok-card [loading]="state.loading()">
    <ok-expand-list
      [trackBy]="'id'"
      [sort]="state.currentSort()"
      [data]="state.pricePoliciesState().items"
      [configuration]="config()"
      (sortChange)="state.onSortChange($event)">
    </ok-expand-list>
    <mat-paginator
      #paginator
      class="paginator"
      [pageSize]="state.filters().page.pageSize"
      [pageSizeOptions]="state.pagingOptions.pageSizeOptions"
      [pageIndex]="state.filters().page.pageIndex"
      [length]="state.pricePoliciesState().totalCount"
      (page)="pageSwitch($event)"
      color="accent"
      [disabled]="state.loading()" />
  </ok-card>
</div>

<!-- HEADER TEMPLATES -->
<ng-template #headerBasePriceTemplate>
  <div class="header-column-template">
    <span class="icon header-column-template__title">
      Strømsats
      <span
        class="info-icon"
        matTooltip="Strømsats kan være en fast elpris. Eller en dynamisk pris med bund og loft"
        matTooltipPosition="below">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
      </span>
    </span>
    <p class="header-column-template__sub-title">Ekskl. moms</p>
  </div>
</ng-template>

<ng-template #headerOkSupplementTemplate>
  <div class="header-column-template">
    <span class="header-column-template__title">OK-tillæg </span>
    <p class="header-column-template__sub-title">Ekskl. moms</p>
  </div>
</ng-template>

<ng-template #headerCustomerSupplementTemplate>
  <div class="header-column-template">
    <span class="header-column-template__title">Kundetillæg </span>
    <p class="header-column-template__sub-title">Ekskl. moms</p>
  </div>
</ng-template>

<ng-template #headerConsumerPriceTemplate>
  <div class="header-column-template">
    <span class="icon header-column-template__title">
      Forbrugerpris
      <span
        class="info-icon"
        matTooltip="Forbrugerprisen er den samlede pris inkl. moms og består af strømsats, OK-tillæg og kundetillæg."
        matTooltipPosition="below">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
      </span>
    </span>
    <p class="header-column-template__sub-title">Inkl. moms</p>
  </div>
</ng-template>

<ng-template #headerConnectorTemplate>
  <div class="header-column-template">
    <span class="icon header-column-template__title">
      Stik (lokation)
      <span class="info-icon" matTooltip="Tilknyttede ladestik (lokationer med prispolitikken som standard)" matTooltipPosition="below">
        <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
      </span>
    </span>
  </div>
</ng-template>

<!-- ROW TEMPLATES -->
<ng-template #rowTypeTemplate let-item>{{ item.type | translatePricePolicyType }}</ng-template>

<ng-template #rowConnectingTemplate let-item>
  @if (item.organizationId) {
    <a class="blue" [routerLink]="['/organizations']" [queryParams]="{ organizationId: item.organizationId }">
      {{ item.organizationName ?? '-' }}
    </a>
  } @else {
    Global
  }
</ng-template>

<ng-template #rowBasePriceTemplate let-item>
  @if (item.basePriceInKrWithoutVat.fixed) {
    {{ item.basePriceInKrWithoutVat.fixed.value | dkCurrency }}
  } @else if (item.basePriceInKrWithoutVat.dynamic) {
    {{ item.basePriceInKrWithoutVat.dynamic.low | dkCurrency }} - {{ item.basePriceInKrWithoutVat.dynamic.high | dkCurrency }}
  }
</ng-template>

<ng-template #rowOkSupplementTemplate let-item>
  @if (item.okSupplementInKrWithoutVat !== null) {
    {{ item.okSupplementInKrWithoutVat | dkCurrency }}
  } @else {
    -
  }
</ng-template>

<ng-template #rowCustomerSupplementTemplate let-item>
  @if (item.organizationSupplementInKrWithoutVat !== null) {
    {{ item.organizationSupplementInKrWithoutVat | dkCurrency }}
  } @else {
    -
  }
</ng-template>

<ng-template #rowConsumerPriceTemplate let-item>
  @if (item.consumerPriceInKrWithVat.fixed) {
    {{ item.consumerPriceInKrWithVat.fixed.value | dkCurrency }}
  } @else if (item.consumerPriceInKrWithVat.dynamic) {
    {{ item.consumerPriceInKrWithVat.dynamic.low | dkCurrency }} - {{ item.consumerPriceInKrWithVat.dynamic.high | dkCurrency }}
  }
</ng-template>

<ng-template #rowConnectorsTemplate let-item>
  <a [routerLink]="['/locations']" [queryParams]="{ pricePolicyId: item.id }" class="blue">
    {{ item.connectorInfo.connectorCount }} ({{ item.connectorInfo.connectorCountDefaultPricePolicy ?? 0 }})</a
  >
</ng-template>
